module.exports = __webpack_public_path__ + "img/img43.e3c37491.png";